var DateHelpers =
/** @class */
function () {
  function DateHelpers() {}
  /**
   * Helper to check if today is between the specified date range.
   * @param validFrom Optional value to use as lower boundary.
   * @param validTo Optional value to use as upper boundary.
   */


  DateHelpers.isTodayBetween = function (validFrom, validTo) {
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (validFrom !== undefined) {
      var validFromDate = new Date(validFrom);

      if (validFromDate > currentDate) {
        return false;
      }
    }

    if (validTo !== undefined) {
      var validToDate = new Date(validTo);

      if (validToDate < currentDate) {
        return false;
      }
    }

    return true;
  };

  return DateHelpers;
}();

export { DateHelpers };